import { toJsxRuntime } from "hast-util-to-jsx-runtime";
import bash from "highlight.js/lib/languages/bash";
import json from "highlight.js/lib/languages/json";
import python from "highlight.js/lib/languages/python";
import toml from "highlight.js/lib/languages/ini";
import { createLowlight } from "lowlight";
import type { ReactNode } from "react";
import { Fragment, jsx, jsxs } from "react/jsx-runtime";

/**
 * Syntax highlighting for the four things a student pastes: Python, a shell line, a
 * pyproject.toml fragment, JSON. Nothing else is registered, so nothing else is shipped.
 *
 * Tokens come back as `<span class="hljs-…">`; their colours are in index.css against the
 * site's own light and dark tokens, not a bundled theme.
 */

const lowlight = createLowlight({ python, bash, sh: bash, shell: bash, toml, json });

export type Language = "python" | "bash" | "sh" | "shell" | "toml" | "json";

const ALIASES: Record<string, Language> = {
  py: "python",
  python: "python",
  bash: "bash",
  sh: "sh",
  shell: "shell",
  zsh: "bash",
  console: "bash",
  toml: "toml",
  json: "json",
};

export function highlight(code: string, language?: string): ReactNode {
  const name = language === undefined ? undefined : ALIASES[language.toLowerCase()];
  if (name === undefined) return code;
  const tree = lowlight.highlight(name, code);
  return toJsxRuntime(tree, { Fragment, jsx, jsxs });
}
